import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { type Styles, css } from "../../../../styled-system/css";
import miyagiWin from "../../../assets/miyagi/win.png";
import Header from "../../../components/header";
import { TENANT_APP_NAMES } from "../../../config";
import { useFooter } from "../../../contexts/footer-context";
import { t } from "../../../libs/i18n";

type ProcessingSearch = {
  campaign?:
    | "r7OnSignup"
    | "r8AntiInflation"
    | "r8OnSignup"
    | "r8MiyagiResidenceCard";
};

export const Route = createFileRoute("/_authed/lottery/grant/processing")({
  validateSearch: (search: Record<string, unknown>): ProcessingSearch => {
    return {
      campaign: (search.campaign as ProcessingSearch["campaign"]) ?? undefined,
    };
  },
  loader: async ({ context: { tenant } }) => {
    return { tenant };
  },
  component: Processing,
});

const loading: Styles = {
  display: "inline-block",
  width: "100%",
  height: "100%",
  background: "linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%)",
  backgroundSize: "200% 100%",
  animation: "1.2s shine linear infinite",
};

const dot: Styles = {
  w: "20px",
  h: "20px",
  bg: "blue.400",
  rounded: "full",
  animation: "bounce 1.2s infinite ease-in-out",
};

function Processing() {
  const navigate = useNavigate();
  const { tenant } = Route.useLoaderData();
  const { campaign } = Route.useSearch();
  const { setDisabled: setFooterDisabled } = useFooter();

  useEffect(() => {
    setFooterDisabled(true);

    return () => {
      setFooterDisabled(false);
    };
  }, [setFooterDisabled]);

  // 次画面の画像をプリロードする（みやぎのみ専用画像を使用）
  useEffect(() => {
    if (tenant.slug === "miyagi") {
      const img = new Image();
      img.src = miyagiWin;
    }
  }, [tenant.slug]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({
        to: "/lottery/apply",
        search: campaign ? { campaign } : undefined,
      });
    }, 2000);

    return () => clearTimeout(timeout);
  }, [navigate, campaign]);

  const headerTitle = TENANT_APP_NAMES[tenant.slug] ?? tenant.name;

  return (
    <>
      <Header title={headerTitle} />
      <div
        className={css({
          p: "20px",
        })}
      >
        <section
          className={css({
            bg: "white",
            pb: "28px",
            rounded: "2xl",
          })}
        >
          <div
            className={css({
              bg: "surface.disable",
              height: "112px",
              roundedTop: "2xl",
            })}
          >
            <div className={css({ ...loading, roundedTop: "2xl" })} />
          </div>
          <div
            className={css({
              display: "flex",
              flexDir: "column",
              gap: "24px",
              px: "38px",
            })}
          >
            <div
              className={css({
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                mt: "24px",
              })}
            >
              <div className={css({ ...dot, animationDelay: "0s" })} />
              <div className={css({ ...dot, animationDelay: "0.2s" })} />
              <div className={css({ ...dot, animationDelay: "0.4s" })} />
              <div className={css({ ...dot, animationDelay: "0.6s" })} />
            </div>
            <h1
              className={css({
                textAlign: "center",
              })}
            >
              {t("応募中...")}
            </h1>
            <div
              className={css({
                h: "55px",
                w: "full",
              })}
            >
              <div className={css(loading)} />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
